import './base.css';
import './dropdown.css';
import app from "./app";
import ctas from "./ctas";
import header from "./header";
import landing from "./landing";
import background from "./background";
import editor from "./editor";
import generic from "./generic";
import label from "./label";
import cookie from "./cookie";
import video from "./video";
import error from "./error";
import editMain from "./edit-main";
import filter from "./filter";
import crop from "./crop";
import text from "./text";
import productSelector from "./product-selector.css";
import footer from "./footer.css";


export default {
  app,
  ctas,
  header,
  landing,
  background,
  editor,
  generic,
  label,
  cookie,
  video,
  error,
  editMain,
  filter,
  crop,
  text,
  productSelector,
  footer
};



// WEBPACK FOOTER //
// ./src/styles/index.js